import React from "react";
import { Coins, Crown, LayoutGrid, Wallet } from "lucide-react";

const TABS = [
  { id: "overview", label: "Overview", Icon: LayoutGrid },
  { id: "earn", label: "Earning Rules", Icon: Coins },
  { id: "redeem", label: "Redemption", Icon: Wallet },
  { id: "tiers", label: "Membership Tiers", Icon: Crown },
];

const SubTabs = ({ active, onChange }) => (
  <div className="flex items-center gap-1 px-6 border-b border-[#E6E9EF] overflow-x-auto bg-white">
    {TABS.map((t) => {
      const isActive = active === t.id;
      return (
        <button
          key={t.id}
          onClick={() => onChange(t.id)}
          className={`flex items-center gap-2 px-3.5 py-3 text-[13px] font-semibold whitespace-nowrap border-b-2 -mb-px transition-colors ${
            isActive
              ? "border-primary text-primary"
              : "border-transparent text-[#64748B] hover:text-[#334155]"
          }`}
        >
          <t.Icon size={16} />
          {t.label}
        </button>
      );
    })}
  </div>
);

export default SubTabs;
export { TABS };
